export default __webpack_public_path__ + "static/media/Mittfisk_7.c808c760.jpg";